import { cj } from 'src/utils/classNames';

export default function FeeTierModalActiveIndicator() {
	return (
		<div
			className={cj(
				'absolute top-1/2 left-2 -translate-y-1/2',
				'size-1.5 rounded-full bg-purple-link'
			)}
		/>
	);
}
